export const categoryConstants = {
    GET_CATEGORIES_REQUEST: 'GET_CATEGORIES_REQUEST',
    GET_CATEGORIES_SUCCESS: 'GET_CATEGORIES_SUCCESS',
    GET_CATEGORIES_FAILURE: 'GET_CATEGORIES_FAILURE',

    GET_PARENT_CATEGORIES_REQUEST: 'GET_PARENT_CATEGORIES_REQUEST',
    GET_PARENT_CATEGORIES_SUCCESS: 'GET_PARENT_CATEGORIES_SUCCESS',
    GET_PARENT_CATEGORIES_FAILURE: 'GET_PARENT_CATEGORIES_FAILURE',

    GET_THEME_PACKAGES_REQUEST: 'GET_THEME_PACKAGES_REQUEST',
    GET_THEME_PACKAGES_SUCCESS: 'GET_THEME_PACKAGES_SUCCESS',
    GET_THEME_PACKAGES_FAILURE: 'GET_THEME_PACKAGES_FAILURE',

    ADD_CATEGORY_TO_THEME_PACKAGE_REQUEST: 'ADD_CATEGORY_TO_THEME_PACKAGE_REQUEST',
    ADD_CATEGORY_TO_THEME_PACKAGE_SUCCESS: 'ADD_CATEGORY_TO_THEME_PACKAGE_SUCCESS',
    ADD_CATEGORY_TO_THEME_PACKAGE_FAILURE: 'ADD_CATEGORY_TO_THEME_PACKAGE_FAILURE',

    ADD_ORGANIZATION_TO_THEME_PACKAGE_REQUEST: 'ADD_ORGANIZATION_TO_THEME_PACKAGE_REQUEST',
    ADD_ORGANIZATION_TO_THEME_PACKAGE_SUCCESS: 'ADD_ORGANIZATION_TO_THEME_PACKAGE_SUCCESS',
    ADD_ORGANIZATION_TO_THEME_PACKAGE_FAILURE: 'ADD_ORGANIZATION_TO_THEME_PACKAGE_FAILURE',

    REMOVE_ORGANIZATION_FROM_THEME_PACKAGE_REQUEST: 'REMOVE_ORGANIZATION_FROM_THEME_PACKAGE_REQUEST',
    REMOVE_ORGANIZATION_FROM_THEME_PACKAGE_SUCCESS: 'REMOVE_ORGANIZATION_FROM_THEME_PACKAGE_SUCCESS',
    REMOVE_ORGANIZATION_FROM_THEME_PACKAGE_FAILURE: 'REMOVE_ORGANIZATION_FROM_THEME_PACKAGE_FAILURE',

    ADD_THEME_PACKAGE_REQUEST: 'ADD_THEME_PACKAGE_REQUEST',
    ADD_THEME_PACKAGE_SUCCESS: 'ADD_THEME_PACKAGE_SUCCESS',
    ADD_THEME_PACKAGE_FAILURE: 'ADD_THEME_PACKAGE_FAILURE',

    ADD_OR_UPDATE_CATEGORY_THEME_REQUEST: 'ADD_OR_UPDATE_CATEGORY_THEME_REQUEST',
    ADD_OR_UPDATE_CATEGORY_THEME_SUCCESS: 'ADD_OR_UPDATE_CATEGORY_THEME_SUCCESS',
    ADD_OR_UPDATE_CATEGORY_THEME_FAILURE: 'ADD_OR_UPDATE_CATEGORY_THEME_FAILURE',

    EDIT_THEME_PACKAGE_REQUEST: 'EDIT_THEME_PACKAGE_REQUEST',
    EDIT_THEME_PACKAGE_SUCCESS: 'EDIT_THEME_PACKAGE_SUCCESS',
    EDIT_THEME_PACKAGE_FAILURE: 'EDIT_THEME_PACKAGE_FAILURE',

    REMOVE_THEME_PACKAGE_REQUEST: 'REMOVE_THEME_PACKAGE_REQUEST',
    REMOVE_THEME_PACKAGE_SUCCESS: 'REMOVE_THEME_PACKAGE_SUCCESS',
    REMOVE_THEME_PACKAGE_FAILURE: 'REMOVE_THEME_PACKAGE_FAILURE',

    REMOVE_THEME_REQUEST: 'REMOVE_THEME_REQUEST',
    REMOVE_THEME_SUCCESS: 'REMOVE_THEME_SUCCESS',
    REMOVE_THEME_FAILURE: 'REMOVE_THEME_FAILURE',

    TEST_MODELS_REQUEST: 'TEST_MODELS_REQUEST',
    TEST_MODELS_SUCCESS: 'TEST_MODELS_SUCCESS',
    TEST_MODELS_FAILURE: 'TEST_MODELS_FAILURE',

    GET_CONTRACT_TYPES_REQUEST: 'GET_CONTRACT_TYPES_REQUEST',
    GET_CONTRACT_TYPES_SUCCESS: 'GET_CONTRACT_TYPES_SUCCESS',
    GET_CONTRACT_TYPES_FAILURE: 'GET_CONTRACT_TYPES_FAILURE'
};


// WEBPACK FOOTER //
// ./src/constants/category.constants.js